import type { operations } from "@tamariba/api-client";

export type SkillCategories =
  operations["listSkillCategories"]["responses"][200]["content"]["application/json"];
export type SkillCategory = SkillCategories[number];
export type Skill = SkillCategory["skills"][number];
export type Weaknesses =
  operations["listWeaknesses"]["responses"][200]["content"]["application/json"];
export type Weakness = Weaknesses[number];
export type WeaknessWrite =
  operations["saveWeakness"]["requestBody"]["content"]["application/json"];
export type SkillDrills =
  operations["listSkillDrills"]["responses"][200]["content"]["application/json"];
export type SkillDrill = SkillDrills["drills"][number];
export type SelectionCollectionWrite =
  operations["createDrillSelectionCollection"]["requestBody"]["content"]["application/json"];
export type SelectionCollection =
  operations["createDrillSelectionCollection"]["responses"][200]["content"]["application/json"];

export function weaknessLabel(weakness: Pick<Weakness, "skills">) {
  return (
    weakness.skills.map((skill) => skill.label).join(" × ") || "スキル未選択"
  );
}
